// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__s5d7p","page":"PageHeader_page__A+JZC","message":"PageHeader_message__5UVsY"};